import type {
  PermanentFlag,
  PermanentFlagValue,
  TemporaryFlag,
} from './types.ts';

export const temporary = (
  expirationDate: string,
  defaultValue = false,
): TemporaryFlag => ({
  kind: 'temporary',
  defaultValue,
  expirationDate,
});

export const permanent = <T extends PermanentFlagValue>(
  defaultValue: T,
): PermanentFlag<T> => ({
  kind: 'permanent',
  defaultValue,
});

export const FLAG_REGISTRY = {
  // 'example.temporary-flag': temporary('2026-06-01'),
  // 'example.permanent-flag': permanent(1),
  'authorization.permission-guard': temporary('2027-03-31'),
  'authorization.roles-ui': temporary('2027-03-31'),
  'meal-vouchers.ui.hr-manual-assignment': temporary('2027-03-31'),
  'meal-vouchers.ui.v3.employee_details': temporary('2027-03-31'),
  'meal-vouchers.ui.v3.card_orders': temporary('2027-03-31'),
  'meal-vouchers.ui.bo.module-setup': temporary('2027-03-31'),
  'cancel-welfare-source.bo.feature.complete-plan-assignment-detail.release':
    permanent(false),
  'cancel-welfare-source.bo.feature.complete-plan-reversals.release':
    permanent(false),
} as const satisfies Record<string, TemporaryFlag | PermanentFlag>;

export type FlagKey = keyof typeof FLAG_REGISTRY;

export type FlagDefinitionFor<K extends FlagKey> = (typeof FLAG_REGISTRY)[K];
